// The one place that talks to the Site File Sharing API. Errors surface
// synchronously — the whole point of retiring the flows.
import type { SwmsType } from './types';
import { createApiClient, feedbackSender } from '@higgins/utils';
import { getAccessToken } from './msal';

export { ApiError } from '@higgins/utils';

// Headers, ApiError and the lost-reply handling come from the shared client (#312).
const { json: apiFetch } = createApiClient({ getToken: getAccessToken });

export interface MeResponse { name: string; upn: string; entitled: boolean }

export interface SwmsCatalogueResponse {
  source: 'live' | 'bundled';
  catalogue: Record<SwmsType, Array<{ name: string; path: string }>>;
}

export interface WorkOrderOption { id: string; name: string; detail: string }

export const getWorkOrders = (jobCode: string) =>
  apiFetch<{ workOrders: WorkOrderOption[] }>(`/workorders?job=${encodeURIComponent(jobCode)}`);

export interface ShareResponse {
  jobCode: string;
  siteUrl: string;
  siteSource: string;
  copied: string[];
  queued: string[];
  /** Already in the job's Site File and edited there — left as they are (SR-57386). */
  kept: string[];
  /** The job's copy couldn't be checked — left alone rather than risk overwriting it. */
  notChecked: string[];
  linkUrl: string;
  emailedTo: string[];
  registered: 'created' | 'failed' | 'skipped';
  workOrder: string | null;
  workOrderStamped: 'stamped' | 'failed' | 'skipped';
}

export const getMe = () => apiFetch<MeResponse>('/me');
export const getSwmsCatalogue = () => apiFetch<SwmsCatalogueResponse>('/swms');
export const postShare = (body: {
  swmsType: SwmsType; jobCode: string; swms: string[]; subbieEmails: string[];
  workOrderId?: string; workOrderName?: string;
}) => apiFetch<ShareResponse>('/share', { method: 'POST', body: JSON.stringify(body) });

/** POST /api/feedback — the header's Report a problem / Suggest button (#511). */
export const sendFeedback = feedbackSender(apiFetch);
